import { EconomicAnalysis } from './economic-analysis';
import { EconomicAnalysisRange } from './economic-analysis-range';
import { EconomicAnalysisType } from './economic-analysis-type';

export class CompSearchEconomicAnalyses {
  economicAnalysis: EconomicAnalysis[];
  economicAnalysisRanges: EconomicAnalysisRange[];
  economicAnalysisTypes: EconomicAnalysisType[];
}
